import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { Link } from "react-router-dom";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function SelectService({ open, token }) {
  console.log(open, "ipaksdj");
  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        // onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Please select the service type?"}</DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-slide-description"
            className="p-4 ml-4"
          >
            <Button variant="outlined" color="success" className="ml-5">
              <Link to="/add-restaurant">Add Restaurant</Link>
            </Button>
            <Button variant="outlined" color="success" className="ml-4">
              <Link to="/add-grocery">Add Grocery</Link>
            </Button>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}
